/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import ProgressBarWidget from '../../../../shared/ProgressBar/ProgressBarWidget';
import {
  IAggregationData,
  scaledData
} from '../../../../shared/ProgressBar/IProgressBarWidget';

interface ISiteEnergyUsageComponentProps {
  unit: string;
  aggregationData: IAggregationData;
  category: string;
  deviationScaledData?: scaledData;
  originalUnit?: string;
  conversionType?: string;
  basicSub?: boolean;
}

const SiteEnergyUsageComponent = (props: ISiteEnergyUsageComponentProps) => {
  const {
    unit,
    category,
    aggregationData,
    deviationScaledData,
    originalUnit,
    conversionType,
    basicSub
  } = props;

  return (
    <ProgressBarWidget
      basicSub={basicSub}
      unit={unit}
      category={category}
      aggregationData={aggregationData}
      isProgressBarForEnergy={true}
      deviationScaledData={deviationScaledData}
      fromCarbonKPI={true}
      originalUnit={originalUnit}
      conversionType={conversionType}
    />
  );
};

export default SiteEnergyUsageComponent;
